const CircleClockIcon = ({ className }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="48" height="48" rx="24" fill="#FF0000" />
      <path
        d="M24.75 20C24.75 19.5858 24.4142 19.25 24 19.25C23.5858 19.25 23.25 19.5858 23.25 20V24C23.25 24.1989 23.329 24.3897 23.4697 24.5303L25.4697 26.5303C25.7626 26.8232 26.2374 26.8232 26.5303 26.5303C26.8232 26.2374 26.8232 25.7626 26.5303 25.4697L24.75 23.6893V20Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 13.25C18.0629 13.25 13.25 18.0629 13.25 24C13.25 29.9371 18.0629 34.75 24 34.75C29.9371 34.75 34.75 29.9371 34.75 24C34.75 18.0629 29.9371 13.25 24 13.25ZM14.75 24C14.75 18.8914 18.8914 14.75 24 14.75C29.1086 14.75 33.25 18.8914 33.25 24C33.25 29.1086 29.1086 33.25 24 33.25C18.8914 33.25 14.75 29.1086 14.75 24Z"
        fill="white"
      />
    </svg>
  );
};

export default CircleClockIcon;
